// Module
var code = `<div class="rb-input-map layout-column flex-100"> <rb-map class="flex-100" center="\$ctrl.center" zoom="\$ctrl.zoom"> <rb-input-marker position="\$ctrl.center" draggable="true"></rb-input-marker> </rb-map> <div class="map-hint">Drag marker on correct address coordinates</div> </div> `;
// Exports
export default code;